import { fromJS, Map, List } from 'immutable';

export function update(state, action) {
    const { id, tags } = action;

    let collections = state.get('collections') || Map();

    collections = collections.set(id, fromJS(tags));

    return state.set('collections', collections);
}
